import { useState } from "react";
import { Box, Card, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PageContainer from "../../../components/container/PageContainer";
import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";
import MedicalCardPage from '../medical-card/MedicalCardPage';
import OfficeIdCardPage from '../office-id-card/OfficeIdCardPage';
import ContractIdCardPage from '../contract-id-card/ContractIdCardPage';

const IDCardsPage = () => {
    const [value, setValue] = useState("1");

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const BCrumb = [
        { to: "/", title: "HR Management" },
        { title: "Cards" },
    ];

    return (
        <PageContainer title="Cards">
            <Breadcrumb title="Cards" items={BCrumb} />

            <Card>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList onChange={handleTabChange} variant="fullWidth">
                            <Tab label="Medical Card" value="1" />
                            <Tab label="Office ID Card" value="2" />
                            <Tab label="Contract ID Card" value="3" />
                        </TabList>
                    </Box>

                    <TabPanel value="1">
                        <MedicalCardPage />
                    </TabPanel>

                    <TabPanel value="2">
                        <OfficeIdCardPage />
                    </TabPanel>

                    <TabPanel value="3">
                        <ContractIdCardPage />
                    </TabPanel>
                </TabContext>
            </Card>
        </PageContainer>
    );
};

export default IDCardsPage;